import { useState } from 'react'
import { useDropzone } from 'react-dropzone'

import { errors } from 'constants/errors'

import { DragAndDropCore } from './@types'
import { DragAndDropArea, DragAndDropText, DragAndDropErrorText } from './Style'

function DragAndDrop({ acceptFile, transmitData }: DragAndDropCore) {
  const [error, setError] = useState('')

  const { getRootProps, getInputProps } = useDropzone({
    accept: acceptFile,
    multiple: false,
    maxSize: Infinity,
    minSize: 0,
    onDrop: (acceptedFiles, fileRejections, event) => {
      event.preventDefault()
      if (fileRejections) {
        setError(errors.validation.INVALID_FILE)
      }
      if (acceptedFiles[0]) {
        transmitData(acceptedFiles[0])
      }
    },
  })

  return (
    <>
      <DragAndDropArea {...getRootProps({ className: 'dropzone disabled' })} isError={error !== ''}>
        <input {...getInputProps()} />
        {error ? (
          <DragAndDropErrorText>{error}</DragAndDropErrorText>
        ) : (
          <DragAndDropText>Drag&rsquo;n&rsquo;drop some files here, or&nbsp;click to&nbsp;select files</DragAndDropText>
        )}
      </DragAndDropArea>
    </>
  )
}

export { DragAndDrop }
